<div class="workexperience-editor">
  <div class="control-custom">
    <div>{{ 'label.From' | translate }}</div>
    <div class="container" style="padding-left: 0px">
      <div class="col-md-1" style="padding-left: 0px">
        <select
          name="fromMonth"
          [ngModel]="workExperience && workExperience.dateFromMonth"
          (ngModelChange)="
            workExperience && (workExperience.dateFromMonth = $event)
          "
          convert-to-number
        >
          <option *ngFor="let item of monthListFull" value="{{ item.value }}">
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <select
          name="fromYear"
          [ngModel]="workExperience && workExperience.dateFromYear"
          (ngModelChange)="
            workExperience && (workExperience.dateFromYear = $event)
          "
          convert-to-number
        >
          <option *ngFor="let item of yearList" value="{{ item.value }}">
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-10">
        <input
          type="checkbox"
          [ngModel]="workExperience && workExperience.isCurrent"
          (ngModelChange)="
            workExperience &&
              ((workExperience.isCurrent = $event) || true) &&
              onCurrentWorkChange()
          "
        /><span>{{ 'label.ICurrentlyWorkHere' | translate }}</span>
      </div>
      <!--div class="col-md-10">&nbsp; </div-->
      <div class="col-md-1" style="padding-left: 0px">
        <!--<cd-field-state data-name="WorkExperience_DateFromMonth"></cd-field-state>-->
        <hr-field-state-marker
          [field]="field?.dateFromMonth"
        ></hr-field-state-marker>
      </div>
      <div class="col-md-11" style="padding-left: 0px">
        <!--<cd-field-state data-name="WorkExperience_DateFromYear"></cd-field-state>-->
        <hr-field-state-marker
          [field]="field?.dateFromYear"
        ></hr-field-state-marker>
      </div>
    </div>
  </div>
  <div class="control-custom" *ngIf="!workExperience?.isCurrent">
    <div>{{ 'label.To' | translate }}</div>
    <div class="container" style="padding-left: 0px">
      <div class="col-md-1" style="padding-left: 0px">
        <select
          name="toMonth"
          [ngModel]="workExperience && workExperience.dateToMonth"
          (ngModelChange)="
            workExperience && (workExperience.dateToMonth = $event)
          "
          convert-to-number
        >
          <option *ngFor="let item of monthListFull" value="{{ item.value }}">
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-11" style="padding-left: 0px">
        <select
          name="toYear"
          [ngModel]="workExperience && workExperience.dateToYear"
          (ngModelChange)="
            workExperience && (workExperience.dateToYear = $event)
          "
          convert-to-number
        >
          <option *ngFor="let item of yearList" value="{{ item.value }}">
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <!--<cd-field-state data-name="WorkExperience_DateToMonth"></cd-field-state>-->
        <hr-field-state-marker
          [field]="field?.dateToMonth"
        ></hr-field-state-marker>
      </div>
      <div class="col-md-11" style="padding-left: 0px">
        <!--<cd-field-state data-name="WorkExperience_DateToYear"></cd-field-state>-->
        <hr-field-state-marker
          [field]="field?.dateToYear"
        ></hr-field-state-marker>
      </div>
    </div>
  </div>
  <div class="control-custom">
    <div>{{ 'label.Employer' | translate }}</div>
    <div>
      <input
        type="text"
        name="employer"
        style="width: 300px"
        maxlength="200"
        [ngModel]="workExperience && workExperience.employer"
        (ngModelChange)="workExperience && (workExperience.employer = $event)"
      />
    </div>
    <!--<cd-field-state data-name="WorkExperience_Employer"></cd-field-state>-->
    <hr-field-state-marker [field]="field?.employer"></hr-field-state-marker>
  </div>
  <div class="control-custom">
    <div>{{ 'label.PositionTitle' | translate }}</div>
    <div>
      <input
        type="text"
        name="institution"
        style="width: 300px"
        maxlength="200"
        [ngModel]="workExperience && workExperience.positionTitle"
        (ngModelChange)="
          workExperience && (workExperience.positionTitle = $event)
        "
      />
    </div>
    <!--<cd-field-state data-name="WorkExperience_PositionTitle"></cd-field-state>-->
    <hr-field-state-marker
      [field]="field?.positionTitle"
    ></hr-field-state-marker>
  </div>
  <div class="control-custom">
    <div>{{ 'label.IndustryCategory' | translate }}</div>
    <div class="multi-select-dropdown">
      <ul>
        <li *ngFor="let category of selectedCategories">
          {{ category?.name
          }}<button
            class="remove"
            (click)="onWorkExperienceCategoryOptionRemoveClick(category)"
          >
            x
          </button>
        </li>
      </ul>
    </div>

    <p-multiSelect
      [options]="categoryOptions"
      [(ngModel)]="selectedCategories"
      (onChange)="onCategoryFilterChange($event)"
      [filter]="true"
      [maxSelectedLabels]="0"
      [showToggleAll]="false"
      selectedItemsLabel="{{ 'label.Selected' | translate }}: {0}"
      [style]="{ width: '300px' }"
    >
      <ng-template let-item pTemplate="item">
        <span
          (click)="onCategoryClick(item.value)"
          class="{{
            item.value.isHeadOld()
              ? 'head-occupation-category'
              : 'occupation-category'
          }}"
          >{{ item.label }}</span
        >
      </ng-template>
    </p-multiSelect>
    <p *ngIf="maxCategoriesExceeded" class="error">
      {{ 'message.WorkExperienceMaxCategoriesExceeded' | translate }}
    </p>
    <hr-field-state-marker [field]="field?.categories"></hr-field-state-marker>
  </div>
  <div class="control-custom">
    <div>{{ 'label.JobDescription' | translate }}</div>
    <div style="max-width: 500px">
      <ckeditor
        [ngModel]="workExperience && workExperience.description"
        (ngModelChange)="
          workExperience && (workExperience.description = $event)
        "
      ></ckeditor>
    </div>
    <hr-field-state-marker [field]="field?.description"></hr-field-state-marker>
  </div>
  <div class="control-custom">
    <div>{{ 'label.AttachmentEgRecommendationLetter' | translate }}</div>
    <div *ngIf="workExperience?.attachment != null">
      <span>{{ workExperience.attachment.fileName }} &nbsp; &nbsp;</span>
      <button (click)="onDeleteWorkExperienceAttachmentClick(workExperience)">
        {{ 'label.Delete' | translate }}
      </button>
    </div>
    <!--<div>
            <input placeholder="{{'label.SelectFile' | translate }}" type="file" ngFileSelect [options]="uploadOptions" (onUpload)="handleUpload($event)" (beforeUpload)="beforeUpload($event)">
            <span *ngIf="workExperience?.attachment != null">{{'label.ReplaceAttachment' | translate }}</span>
        </div>-->
  </div>
  <div class="control-custom" style="margin-top: 15px">
    <button class="btn btn-default" (click)="onSaveWorkExperienceClick()">
      {{ 'label.Save' | translate }}
    </button>
    <button class="btn btn-default" (click)="onCancelAddWorkExperienceClick()">
      {{ 'label.Cancel' | translate }}
    </button>
  </div>
</div>
